const pageHeaders = [
    {
        test: (path) => /\/inventoryAdd\/?$/.test(path),
        title: 'Add Inventory',
        subtitle: 'Select a seller account first, then search or add inventory.',
    },
    {
        test: (path) => /\/inventory-add\/?$/.test(path),
        title: 'Add Items',
        subtitle: 'Add new inventory items to your store.',
    },
    {
        test: (path) => /\/productAdd\/?$/.test(path) || /\/product-add\/?$/.test(path),
        title: 'Add Product',
        subtitle: 'Create a reusable catalog product that inventory items can link to.',
    },
    {
        test: (path) => /\/(stock-calls|request-item)\/?$/.test(path),
        title: 'Stock Calls',
        subtitle: 'Manage stock calls from customers and staff.',
    },
    {
        test: (path) => /\/inventory\/trash\/?$/.test(path),
        title: 'Trash',
        subtitle: 'Find deleted items and restore them to your inventory.',
    },
    {
        test: (path) => /\/inventory\/purchase-orders\/acquisitions\/?$/.test(path),
        title: 'Acquisitions',
        subtitle: 'Scan items, evaluate market value, and complete the buy.',
    },
    {
        test: (path) => /\/inventory\/purchase-orders\/?$/.test(path),
        title: 'Purchase Orders',
        subtitle: 'Track vendor orders, receiving, payments, and sell-through.',
    },
    {
        test: (path) => /\/inventory\/print-queue\/?$/.test(path),
        title: 'Print Queue',
        subtitle: 'All items and products in queue to be labeled.',
    },
    {
        test: (path) => /\/inventory\/export\/?$/.test(path),
        title: 'Export',
        subtitle: 'Export inventory data from your store.',
    },
    {
        test: (path) => /\/inventory\/exports\/?$/.test(path),
        title: 'Exports',
        subtitle: 'View export history and downloads.',
    },
    {
        test: (path) => /\/inventory\/incoming\/?$/.test(path),
        title: 'Incoming',
        subtitle: 'Track incoming inventory shipments.',
    },
    {
        test: (path) => /\/inventory\/withdrawal\/history\/?$/.test(path),
        title: 'Withdrawal History',
        subtitle: 'Review past inventory withdrawal requests.',
    },
    {
        test: (path) => /\/inventory\/withdrawal\/?$/.test(path),
        title: 'Withdrawal',
        subtitle: 'Manage inventory withdrawal requests.',
    },
    {
        test: (path) => /\/inventory\/item\/[^/]+\/?$/.test(path),
        title: 'Inventory Item',
        subtitle: 'View and manage inventory item details.',
    },
    {
        test: (path) => /\/inventory\/?$/.test(path),
        title: 'Inventory',
        subtitle: 'Browse, search, and manage your store inventory.',
        consignerSubtitle: 'View and manage your consigned inventory',
    },
    {
        test: (path) => /\/products\/brands\/?$/.test(path),
        title: 'Brands',
        subtitle: 'Manage brand names, clean up duplicates, and review brand activity.',
    },
    {
        test: (path) => /\/products\/[^/]+\/?$/.test(path) && !/\/products\/?$/.test(path),
        title: 'Product',
        subtitle: 'View product details and performance.',
    },
    {
        test: (path) => /\/products\/?$/.test(path),
        title: 'Product Directory',
        subtitle: 'Browse and manage your product catalog.',
    },
    {
        test: (path) => /\/audit\/audit-view\/[^/]+\/?$/.test(path),
        title: 'Audit View',
        subtitle: 'Review audit results and item discrepancies.',
    },
    {
        test: (path) => /\/audit\/?$/.test(path),
        title: 'Audits',
        subtitle: 'Run and review inventory audits.',
    },
    {
        test: (path) => /\/price\/history\/?$/.test(path),
        title: 'Price History',
        subtitle: 'Review past price change activity.',
    },
    {
        test: (path) => /\/price\/?$/.test(path),
        title: 'Price Changes',
        subtitle: 'Manage and review inventory pricing updates.',
    },
    {
        test: (path) => /\/reports(\/|$)/.test(path),
        title: 'Reports',
        subtitle: 'Live inventory snapshot, sales & profit reports, and product-level insights.',
    },
    {
        test: (path) => /\/users\/?$/.test(path),
        title: 'Manage Users',
        subtitle: 'Manage employees, consignors, approvals, and user account access.',
    },
    {
        test: (path) => /\/users\//.test(path),
        title: 'Users',
        subtitle: 'Manage user accounts and permissions.',
    },
    {
        test: (path) => /\/consigner\/home\/?$/.test(path),
        title: 'Consigner Dashboard',
        subtitle: 'Your consignment overview and activity.',
    },
    {
        test: (path) => /\/consigner\/payouts(\/|$)/.test(path),
        title: 'Payouts',
        subtitle: 'Track your sales earnings and payout history.',
    },
    {
        test: (path) => /\/home\/?$/.test(path),
        title: 'Dashboard',
        subtitle: 'Your daily command center for inventory, sales, orders, and channel performance.',
    },
    {
        test: (path) => /\/payouts\/history\/[^/]+(\/|$)/.test(path),
        title: 'Payout detail',
        subtitle: 'Items included in this issued payout.',
    },
    {
        test: (path) => /\/payouts\/history(\/|$)/.test(path),
        title: 'Payment history',
        subtitle: 'All issued payouts, recipients, and payment details.',
    },
    {
        test: (path) => /\/payouts\/legacy(\/|$)/.test(path),
        title: 'Payouts',
        subtitle: 'Manage consignor payouts and payment history.',
    },
    {
        test: (path) => /\/payouts(\/|$)/.test(path),
        title: 'Payouts',
        subtitle: 'Review seller balances, payout requests, and hold eligibility.',
    },
    {
        test: (path) => /\/transfers(\/|$)/.test(path),
        title: 'Transfers',
        subtitle: 'Track and manage inventory transfers.',
    },
    {
        test: (path) => /\/orders(\/|$)/.test(path),
        title: 'Orders',
        subtitle: 'View and manage store orders.',
    },
    {
        test: (path) => /\/customers(\/|$)/.test(path),
        title: 'Customers',
        subtitle: 'Manage customer accounts and details.',
    },
    {
        test: (path) => /\/b2b(\/|$)/.test(path) || /\/consumer-orders(\/|$)/.test(path),
        title: 'Consumer Orders',
        subtitle: 'Manage consumer order workflow and fulfillment.',
    },
    {
        test: (path) => /\/settings(\/|$)/.test(path),
        title: 'Settings',
        subtitle: 'Configure store preferences, locations, and templates.',
    },
    {
        test: (path) => /\/deliveries(\/|$)/.test(path),
        title: 'Deliveries',
        subtitle: 'Track and manage delivery activity.',
    },
];

export const getPageHeader = (pathname = '') => pageHeaders.find(({ test }) => test(pathname)) ?? null;

export default pageHeaders;
